module.exports = __webpack_public_path__ + "static/img/service_avatar.cef3fadc.png";